import { isInstanceOf, isNodeIdKey, isTypeOrUndefined, } from "./aux";
import { exhaustiveStringTuple, isAdditionalProcess, isArray, isAttachment, isBoolean, isLaserSheetCuttingMinArea, isNumber, isPoint3, isProcess, isProcessType, isScrewThread, isSheet, isSheetCuttingMaterialMapping, isSheetMaterial, isString, isStringIndexedInterface, isTappingDataEntry, isTube, isTubeMaterial, isTubeProfileGeometryCircular, isTubeProfileGeometryRectangular, isTubeProfileGeometryType, isTubeSpecification, isWorkStepType, } from "./wsi4_typeguards";
export function isShopTappingNodeData(arg) {
    const typeGuardMap = {
        candidates: (a) => isArray(a, isTappingCandidate3),
        laserSheetCuttingVertexKey: isString,
        nodeIdKey: isNodeIdKey,
        selection: (a) => isArray(a, isTappingDataEntry),
        svg: isString,
    };
    return isInstanceOf(arg, typeGuardMap);
}
function isStringRecord(t, isT) {
    if (!isStringIndexedInterface(t)) {
        return false;
    }
    return Object.keys(t)
        .find(key => !isT(t[key])) === undefined;
}
function isAttachmentMap(t) {
    return isStringRecord(t, (a) => isArray(a, isAttachment));
}
function isTechnicalDrawingsObject(t) {
    return isStringRecord(t, (arg) => isArray(arg, isString));
}
function isTappingCandidate3(arg) {
    const typeGuardMap = {
        center3: isPoint3,
        matchingScrewThreads: (a) => isArray(a, isScrewThread),
    };
    return isInstanceOf(arg, typeGuardMap);
}
function isTappingNodeData(arg) {
    const typeGuardMap = {
        candidates: (a) => isArray(a, isTappingCandidate3),
        laserSheetCuttingVertexKey: isString,
        selection: (a) => isArray(a, isTappingDataEntry),
        svg: isString,
    };
    return isInstanceOf(arg, typeGuardMap);
}
export function isTubeProfileGeometry(arg) {
    const typeGuardMap = {
        type: isTubeProfileGeometryType,
        content: (a) => isTubeProfileGeometryRectangular(a) || isTubeProfileGeometryCircular(a),
    };
    return isInstanceOf(arg, typeGuardMap);
}
export function isTubeCuttingDataEntry(arg) {
    const typeGuardMap = {
        vertexKey: isString,
        processId: isString,
        dimX: isNumber,
        tubeProfileGeometry: isTubeProfileGeometry,
        tubeMaterialId: (a) => isTypeOrUndefined(a, isString),
        tubeSpecificationId: (a) => isTypeOrUndefined(a, isString),
    };
    return isInstanceOf(arg, typeGuardMap);
}
function isCanForceSheetPartEntry(arg) {
    const typeGuardMap = {
        vertexKey: isString,
        canForce: isBoolean,
    };
    return isInstanceOf(arg, typeGuardMap);
}
function isResourcesObject(arg) {
    const typeGuardMap = {
        attachments: isAttachmentMap,
        gltfs: isResourceEntry,
        pngs: isResourceEntry,
        svgs: isResourceEntry,
        technicalDrawings: isTechnicalDrawingsObject,
        sheetTappingNodeData: (a) => isArray(a, isTappingNodeData),
        tubeCuttingData: (a) => isArray(a, isTubeCuttingDataEntry),
        problematicGeometryGlfts: isResourceEntry,
        canForceSheetPartData: (a) => isArray(a, isCanForceSheetPartEntry),
    };
    return isInstanceOf(arg, typeGuardMap);
}
function isResourceEntry(t) {
    return isStringRecord(t, isString);
}
function isShopUserData(t) {
    const typeGuardMap = {
        material: (a) => isTypeOrUndefined(a, isSheetMaterial),
        doubleSidedMechanicalDeburring: (a) => isTypeOrUndefined(a, isBoolean),
    };
    return isInstanceOf(t, typeGuardMap);
}
function isLevel(t) {
    return t === "fatalError" || t === "recoverableError" || t === "warning" || t === "info";
}
export function isManufacturingStateEntryType(t) {
    const tuple = exhaustiveStringTuple()("unknownError", "constraintContourInBend", "constraintBendFlangeTooShort", "backendIssueInvalidBend", "backendIssueMultipleOuterContours", "backendIssueNestingFailed", "backendIssueUndetectedFeatures", "constraintBendAreasOverlap", "constraintMaxBendLineNetLengthExceeded", "constraintMaxDimensionExceeded", "constraintMaxSheetThicknessExceeded", "constraintMinContourSizeUndercut", "constraintNoBendDeductionFound", "constraintNoBendDieAssigned", "constraintProfileNotSupported", "constraintSheetNotAvailable", "constraintTubeCuttingProcessCompatibility", "constraintTubeNestingNotAvailable", "constraintTubeNotAvailable", "constraintTubeDetectionNotLicensed");
    return tuple.some(key => key === t);
}
function isManufacturingStateEntry(t) {
    const typeGuardMap = {
        type: isManufacturingStateEntryType,
        level: isLevel,
        message: isString,
    };
    return isInstanceOf(t, typeGuardMap);
}
export function isScalePrice(entry) {
    const typeGuardMap = {
        scaleValue: isNumber,
        sellingPrice: isNumber,
    };
    return isInstanceOf(entry, typeGuardMap);
}
export function isManufacturingState(arg) {
    return isArray(arg, isManufacturingStateEntry);
}
export function isNodeObject(t) {
    const typeGuardMap = {
        vertex: isString,
        rootIdKey: isString,
        nodeIdKey: isString,
        name: isString,
        assemblyId: (a) => isTypeOrUndefined(a, isString),
        processId: isString,
        processType: isProcessType,
        workStepType: isWorkStepType,
        processTypeTranslation: isString,
        userData: isShopUserData,
        importMultiplicity: (a) => isTypeOrUndefined(a, isNumber),
        sources: (n) => isArray(n, isString),
        targets: (n) => isArray(n, isString),
        thickness: (n) => isTypeOrUndefined(n, isNumber),
        width: (n) => isTypeOrUndefined(n, isNumber),
        height: (n) => isTypeOrUndefined(n, isNumber),
        actualManufacturingState: isManufacturingState,
        virtualManufacturingState: isManufacturingState,
        forcedProcessType: isBoolean,
        testReportRequired: (n) => isTypeOrUndefined(n, isBoolean),
        testReportPrice: (n) => isTypeOrUndefined(n, isNumber),
        fixedRotations: (a) => isTypeOrUndefined(a, (n) => isArray(n, isNumber)),
        deburringPreviewPrices: (a) => isTypeOrUndefined(a, (n) => isArray(n, isNumber)),
        deburringPrice: (n) => isTypeOrUndefined(n, isNumber),
        cuttingGasId: (a) => isTypeOrUndefined(a, isString),
        flipSide: (n) => isTypeOrUndefined(n, isBoolean),
        comment: (a) => isTypeOrUndefined(a, isString),
        numThreads: (n) => isTypeOrUndefined(n, isNumber),
        numCountersinks: (n) => isTypeOrUndefined(n, isNumber),
        slideGrindingPreviewPrice: (n) => isTypeOrUndefined(n, isNumber),
    };
    return isInstanceOf(t, typeGuardMap);
}
function isArticleObject(t) {
    const typeGuardMap = {
        externalPartNumber: isString,
        externalDrawingNumber: isString,
        externalRevisionNumber: isString,
        name: isString,
        multiplicity: isNumber,
        nodes: (n) => isArray(n, isNodeObject),
        approxPrice: (a) => isTypeOrUndefined(a, isNumber),
        scalePrices: (n) => isArray(n, isScalePrice),
    };
    return isInstanceOf(t, typeGuardMap);
}
export function isProjectObject(arg) {
    const typeGuardMap = {
        creator: isString,
        projectName: isString,
        articles: (a) => isArray(a, isArticleObject),
        resources: isResourcesObject,
        minCompletionTime: (a) => isTypeOrUndefined(a, isNumber),
        netSellingPrice: (a) => isTypeOrUndefined(a, isNumber),
    };
    return isInstanceOf(arg, typeGuardMap);
}
function isShopConfigCuttingGasConfiguration(t) {
    const typeGuardMap = {
        thickness: isNumber,
        sheetMaterial: isSheetMaterial,
        cuttingGasId: isString,
    };
    return isInstanceOf(t, typeGuardMap);
}
function isShopConfigSettings(t) {
    const typeGuardMap = {
        fixedRotationsEnabled: isBoolean,
        testReportRequired: isBoolean,
    };
    return isInstanceOf(t, typeGuardMap);
}
function isMinLowerDieOpeningWidth(t) {
    const typeGuardMap = {
        thickness: (arg) => isNumber(arg),
        openingWidth: (arg) => isNumber(arg),
    };
    return isInstanceOf(t, typeGuardMap);
}
export function isTubeProfileEntry(arg) {
    const typeGuardMap = {
        identifier: isString,
        name: isString,
        description: isString,
        svg: isString,
        geometryType: isTubeProfileGeometryType,
        geometry: (arg) => isTubeProfileGeometryRectangular(arg) || isTubeProfileGeometryCircular(arg),
    };
    return isInstanceOf(arg, typeGuardMap);
}
export function isShopConfig(arg) {
    const typeGuardMap = {
        allowedAdditionalProcesses: (a) => isArray(a, isAdditionalProcess),
        allowedCuttingGasConfigurations: (a) => isArray(a, isShopConfigCuttingGasConfiguration),
        laserSheetCuttingMaterial: (a) => isArray(a, isSheetCuttingMaterialMapping),
        laserSheetCuttingMinAreas: (a) => isArray(a, isLaserSheetCuttingMinArea),
        material: (a) => isArray(a, isSheetMaterial),
        minLowerDieOpeningWidths: (a) => isArray(a, isMinLowerDieOpeningWidth),
        settings: isShopConfigSettings,
        sheets: (a) => isArray(a, isSheet),
        tubeMaterials: (a) => isArray(a, isTubeMaterial),
        tubeProfiles: (a) => isArray(a, isTubeProfileEntry),
        tubeSpecifications: (a) => isArray(a, isTubeSpecification),
        tubes: (a) => isArray(a, isTube),
        minimalScrewDiameter: isNumber,
        tubeCuttingProcesses: (a) => isArray(a, isProcess),
    };
    return isInstanceOf(arg, typeGuardMap);
}
